// extracted by mini-css-extract-plugin
module.exports = {"new-post":"AddCommPost_new-post__1m5_v","alternative":"AddCommPost_alternative__2DO28","heading2z":"AddCommPost_heading2z__-W7ti"};